import { useEffect, useState } from 'react';

export const MAIN_SCROLL_ID = 'main-scroll';
/** Ancla de FormAlert bajo el encabezado de página (Ventas, Cobranzas, etc.) */
export const PAGE_FEEDBACK_ID = 'page-feedback';
/** Espacio bajo la navbar fija al hacer scroll programático */
export const MAIN_SCROLL_TOP_OFFSET = 96;

export function getMainScrollContainer() {
  return document.getElementById(MAIN_SCROLL_ID);
}

/** Evita scroll en body y #main-scroll mientras un modal está abierto. */
export function lockAppScroll() {
  if (typeof document === 'undefined') return;
  document.body.style.overflow = 'hidden';
  document.body.classList.add('modal-open');
  const main = getMainScrollContainer();
  if (main) {
    main.dataset.prevOverflow = main.style.overflow;
    main.style.overflow = 'hidden';
  }
}

export function unlockAppScroll() {
  if (typeof document === 'undefined') return;
  document.body.style.overflow = '';
  document.body.classList.remove('modal-open');
  const main = getMainScrollContainer();
  if (main) {
    main.style.overflow = main.dataset.prevOverflow || '';
    delete main.dataset.prevOverflow;
  }
}

export function scrollMainToId(elementId, offset = MAIN_SCROLL_TOP_OFFSET) {
  const container = getMainScrollContainer();
  const el = document.getElementById(elementId);
  if (!container || !el) return false;

  const containerRect = container.getBoundingClientRect();
  const elRect = el.getBoundingClientRect();
  const top = elRect.top - containerRect.top + container.scrollTop - offset;
  container.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  return true;
}

/** Lleva al usuario a las alertas de la página tras un toast/FormAlert asíncrono. */
export function scrollMainToPageFeedback(offset = MAIN_SCROLL_TOP_OFFSET) {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      if (!scrollMainToId(PAGE_FEEDBACK_ID, offset)) {
        const container = getMainScrollContainer();
        if (container) {
          container.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }
    });
  });
}

/**
 * Resalta la sección cuyo heading ya pasó la línea de lectura dentro de #main-scroll.
 */
export function useMainScrollSpy(sectionIds, readingLineOffset = 112) {
  const [activeId, setActiveId] = useState(sectionIds[0] ?? null);

  useEffect(() => {
    setActiveId(sectionIds[0] ?? null);
  }, [sectionIds]);

  useEffect(() => {
    const container = getMainScrollContainer();
    if (!container || sectionIds.length === 0) return undefined;

    const update = () => {
      const marker = container.getBoundingClientRect().top + readingLineOffset;
      let current = sectionIds[0];
      for (const id of sectionIds) {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= marker) {
          current = id;
        }
      }
      setActiveId(current);
    };

    container.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    const t = requestAnimationFrame(update);
    return () => {
      cancelAnimationFrame(t);
      container.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, [sectionIds, readingLineOffset]);

  return activeId;
}
